module.exports = __webpack_public_path__ + "media/svg/cd-f6335ccc.svg";